import { render, staticRenderFns } from "./NewAddressModal.vue?vue&type=template&id=4b18c8b9"
import script from "./NewAddressModal.vue?vue&type=script&lang=js"
export * from "./NewAddressModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports